import { getAuthToken, getBidderId } from './user';
import {
    LOAD_BIDDER_CARD_STATUS_FAIL,
    LOAD_BIDDER_CARD_STATUS_REQUEST,
    LOAD_BIDDER_CARD_STATUS_SUCCESS,
} from './actions';
import { createSelector } from 'reselect';
import { getBidderCardStatus as getBidderCardStatusAPI } from '@/redux/api/payment';
import { getDeployment } from '@/redux/modules/config';
import { GlobalState } from '../rootReducer';

type BidderCardStatusType = {
    bidderId: number;
    cardId: number;
    isValid: boolean;
    providerId: number;
    updatedDate: string;
};

export type State = {
    isLoading: boolean;
    status: BidderCardStatusType;
};

export const DEFAULT_STATE: State = {
    isLoading: false,
    status: {
        bidderId: 0,
        cardId: 0,
        isValid: false,
        providerId: 0,
        updatedDate: '',
    },
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}): State {
    switch (action.type) {
        case LOAD_BIDDER_CARD_STATUS_SUCCESS:
            return {
                isLoading: false,
                status: action.payload,
            };
        case LOAD_BIDDER_CARD_STATUS_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case LOAD_BIDDER_CARD_STATUS_FAIL:
            return {
                isLoading: false,
                status: { ...DEFAULT_STATE.status },
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.bidderCardStatus;

export const getBidderCardStatusIsLoading = createSelector(stateSelector, (state) => state.isLoading);

export const getBidderCardStatus = createSelector(stateSelector, (state) => state.status);

export const getIsBidderCardValid = createSelector(stateSelector, (state) => state.status.isValid);

/* ACTION CREATORS */
const loadBidderCardStatus =
    ({ authToken, bidderId, deployment }) =>
    async (dispatch) => {
        if (bidderId <= 0) {
            return;
        }
        try {
            dispatch({
                meta: { actionTime: Date.now() },
                payload: authToken,
                type: LOAD_BIDDER_CARD_STATUS_REQUEST,
            });
            const response = await getBidderCardStatusAPI({ authToken, bidderId, deployment });
            return dispatch({
                meta: { actionTime: Date.now() },
                payload: response.payload,
                type: LOAD_BIDDER_CARD_STATUS_SUCCESS,
            });
        } catch (error) {
            dispatch({
                error: true,
                meta: { token: authToken },
                payload: error,
                type: LOAD_BIDDER_CARD_STATUS_FAIL,
            });
        }
    };

export const fetchBidderCardStatusIfNeeded = () => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);
    const bidderId = getBidderId(state);
    if (!getBidderCardStatusIsLoading(state)) {
        return dispatch(loadBidderCardStatus({ authToken, bidderId, deployment }));
    } else {
        return Promise.resolve();
    }
};
